import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import { ProfileCard } from "./ProfileCard";
import { setCurrentPage } from "../redux/navigationSlice.js";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { TrendingProfilesSlider } from "./Trending-profile-slider";
import { Typography, Divider, Popover, Box } from "@mui/material";
import {
  getWithoutTokenAPI,
  getWithTokenAPI,
  postWithTokenAPI,
} from "../util/Api";
import {
  Funnel,
  ChevronDown,
  Calendar,
  ChevronLeft,
  ChevronRight,
  Sparkles,
} from "lucide-react";
import toast from "react-hot-toast";
import Skeleton from "@mui/material/Skeleton";
import ProfileCardsSkeleton from "./ProfileCardsSkeleton.jsx";
import { useTranslation } from "react-i18next";
import { setProfileCount } from "../redux/profileCountSlice.js";

// ✅ SVG Icons
const TodayIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
    <circle cx="12" cy="15" r="1" fill="currentColor"></circle>
    <circle cx="16" cy="15" r="1" fill="currentColor"></circle>
    <circle cx="8" cy="15" r="1" fill="currentColor"></circle>
  </svg>
);

const WeekIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M8 2v4"></path>
    <path d="M16 2v4"></path>
    <rect x="3" y="4" width="18" height="18" rx="2"></rect>
    <path d="M3 10h18"></path>
    <path d="M8 14h.01"></path>
    <path d="M12 14h.01"></path>
    <path d="M16 14h.01"></path>
    <path d="M8 18h.01"></path>
    <path d="M12 18h.01"></path>
    <path d="M16 18h.01"></path>
  </svg>
);

export function ProfileGrid({ onNavigate }) {
  const [profileList, setProfileList] = useState([]);
  console.log(profileList, "PROFILELIST");
  const [trendinglist, setTrendingList] = useState([]);
  console.log(trendinglist, "trendinglist");
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [showSubscribeDialog, setShowSubscribeDialog] = useState(false);
  const [period, setPeriod] = useState("today");
  const [filterAnchor, setFilterAnchor] = useState(null);
  const [currentTrendingIndex, setCurrentTrendingIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const [cardAnimations, setCardAnimations] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  var layoutType = "vertical";
  const data = useSelector((state) => state.user);
  const token = data?.userId?.accessToken;
  const id = data?.userId?.user?._id;
  const { t, i18n } = useTranslation();
  const [trendinglistLoadding, setTrendinglistLoadding] = useState(false);
  const [profileListLoadding, setProfileListtLoadding] = useState(false);
  const completion = useSelector((state) => state.completion.value);
  const [openCompletionDialog, setOpenCompletionDialog] = useState(false);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 500);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    if (token && id) {
      const fetchProfilesList = async () => {
        setProfileListtLoadding(true);
        try {
          const response = await getWithTokenAPI(
            token,
            `/basic-profile/get_others?user_id=${id}&page=1`
          );

          if (response?.statusCode === 200) {
            setProfileList(response?.data?.profiles || []);
          } else {
            setProfileList([]);
          }
        } catch (error) {
          console.error("Error fetching profiles:", error);
        } finally {
          setProfileListtLoadding(false);
        }
      };
      fetchProfilesList();
    } else if (!token && !id) {
      const fetchProfilesListWithoutId = async () => {
        try {
          const response = await getWithoutTokenAPI(`/basic-profile/get_all`);
          if (response?.statusCode === 200) {
            setProfileList(response?.data?.profiles || []);
          } else {
            setProfileList([]);
          }
        } catch (error) {
          console.error("Error fetching profiles without token:", error);
        }
      };
      fetchProfilesListWithoutId();
    }
  }, [token, id]);

  useEffect(() => {
    const loadTrendingProfiles = async () => {
      setTrendinglistLoadding(true);
      try {
        let response;
        if (token && id) {
          response = await getWithTokenAPI(
            token,
            `/trending-profile/get_by_period?period=${period}&user_id=${id}`
          );
        } else {
          response = await getWithoutTokenAPI(
            `/trending-profile/get_by_period?period=week`
          );
        }
        if (response?.statusCode === 200) {
          const trendingData = response.data?.data || [];
          setTrendingList(trendingData);
        } else {
          setTrendingList([]);
        }
        setCurrentTrendingIndex(0);
        setCardAnimations([]);
      } catch (error) {
        console.error("Error loading trending profiles:", error);
        setTrendingList([]);
      } finally {
        setTrendinglistLoadding(false);
      }
    };

    loadTrendingProfiles();
  }, [token, id, period]);

  // ✅ Trending profiles pagination logic
  const PROFILES_PER_PAGE = 4;

  const startIndex = currentTrendingIndex * PROFILES_PER_PAGE;
  const endIndex = startIndex + PROFILES_PER_PAGE;
  const currentTrendingProfiles = trendinglist.slice(startIndex, endIndex);

  const totalTrendingPages = Math.ceil(trendinglist.length / PROFILES_PER_PAGE);
  const showArrows = true;
  const showPrevButton = true;
  const showNextButton = true;

  // Debug logging
  console.log("🎯 Button Visibility:", {
    trendingCount: trendinglist.length,
    currentPage: currentTrendingIndex,
    totalPages: totalTrendingPages,
    showArrows,
    showPrevButton,
    showNextButton,
    currentProfiles: currentTrendingProfiles.length,
  });

  const nextTrending = () => {
    if (currentTrendingIndex < totalTrendingPages - 1) {
      setDirection(1);
      setCardAnimations(Array(PROFILES_PER_PAGE).fill(false));
      setCurrentTrendingIndex((prev) => prev + 1);

      currentTrendingProfiles.forEach((_, index) => {
        setTimeout(() => {
          setCardAnimations((prev) => {
            const newAnimations = [...prev];
            newAnimations[index] = true;
            return newAnimations;
          });
        }, index * 200);
      });
    }
  };

  const prevTrending = () => {
    if (currentTrendingIndex > 0) {
      setDirection(-1);
      setCardAnimations(Array(PROFILES_PER_PAGE).fill(false));
      setCurrentTrendingIndex((prev) => prev - 1);

      currentTrendingProfiles.forEach((_, index) => {
        setTimeout(() => {
          setCardAnimations((prev) => {
            const newAnimations = [...prev];
            newAnimations[index] = true;
            return newAnimations;
          });
        }, index * 200);
      });
    }
  };

  // ✅ Initialize card animations when page changes
  useEffect(() => {
    if (currentTrendingProfiles.length > 0) {
      setCardAnimations(Array(PROFILES_PER_PAGE).fill(false));

      currentTrendingProfiles.forEach((_, index) => {
        setTimeout(() => {
          setCardAnimations((prev) => {
            const newAnimations = [...prev];
            newAnimations[index] = true;
            return newAnimations;
          });
        }, index * 200);
      });
    }
  }, [currentTrendingIndex, trendinglist]);

  // ✅ Animation variants
  const containerVariants = {
    enter: (direction) => ({
      x: direction > 0 ? 100 : -100,
      opacity: 0,
    }),
    center: {
      x: 0,
      opacity: 1,
    },
    exit: (direction) => ({
      x: direction < 0 ? 100 : -100,
      opacity: 0,
    }),
  };

  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 50,
      scale: 0.8,
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
    },
  };

  // ✅ Regular profiles - show only 3 + 1 "View All" card
  const displayProfiles = profileList.slice(0, 4);

  const handleFilterClick = (event) => {
    setFilterAnchor(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchor(null);
  };

  const handlePeriodChange = (value) => {
    if (period === value) {
      // 🔁 Toggle OFF (clear filter)
      setPeriod("all");
      console.log("Period cleared");
    } else {
      // ✅ Apply new filter
      setPeriod(value);
      console.log("Selected Period:", value);
    }
    // You can filter viewerProfiles here if needed
    handleFilterClose();
    console.log("Selected Period:", value);
  };

  const open = Boolean(filterAnchor);

  // parent.jsx

  const handleProfileClick = async (profile) => {
    const progress = Math.round((completion / 4) * 100);
    if (!token) return;
    try {
      const profileId = profile?.basicProfile?.user_id || profile?.user_id;
      const profilename = profile?.basicProfile?.name || profile?.name;
      if (!profileId) {
        console.warn("No profile id found for", profile);
        return;
      }
      if (progress > 75) {
        const payload = { viewer_id: id, viewed_id: profileId };
        const response = await postWithTokenAPI(
          token,
          `/profile-view/track`,
          payload
        );
        if (response?.statusCode === 200) {
          window.scrollTo({ top: 0, behavior: "smooth" });
          navigate(`/view-profile/${profilename.replace(/\s+/g, "-")}`, {
            state: { profileId: profileId },
          });
          dispatch(
            setProfileCount(response?.data?.unique_profiles_viewed_today)
          );
        } else if (response?.statusCode === 403) {
          setShowSubscribeDialog(true);
        } else {
          console.log(response);
        }
      } else {
        setOpenCompletionDialog(true);
      }
    } catch (error) {
      console.error("Error in viewed profile post", error);
    }
  };

  const [sentInterestIds, setSentInterestIds] = useState([]);
  useEffect(() => {
    const fetchInterests = async () => {
      if (!token || !id) return;

      try {
        const sentresponse = await getWithTokenAPI(
          token,
          `/interest/get_send_interest?user_id=${id}`
        );

        const receivers = sentresponse?.data?.receivers || [];

        if (receivers.length > 0) {
          // Extract only the "_id" from each receiver
          const receiverIds = receivers.map((r) => r.user_id);
          setSentInterestIds(receiverIds);
          console.log("Receiver IDs stored:", receiverIds);
        } else {
          setSentInterestIds([]); // No receivers found
        }
      } catch (error) {
        console.error("Error fetching interests:", error);
        setSentInterestIds([]);
      }
    };

    fetchInterests();
  }, [token, id]);

  useEffect(() => {
    if (!trendinglist.length) return;
    setTrendingList((prevList) =>
      prevList.map((item) => {
        const userId = item?.basicProfile?.user_id;
        const isInterested = sentInterestIds.includes(userId);
        return { ...item, interest: isInterested };
      })
    );
  }, [sentInterestIds]);

  useEffect(() => {
    if (!profileList.length) return;
    setProfileList((prevList) => {
      const updatedList = prevList.map((item) => {
        const userId = item?.user_id;
        const isInterested = sentInterestIds.includes(userId);
        return { ...item, interest: isInterested };
      });
      const prevInterests = prevList.map((i) => i.interest);
      const newInterests = updatedList.map((i) => i.interest);
      const isSame =
        JSON.stringify(prevInterests) === JSON.stringify(newInterests);
      return isSame ? prevList : updatedList;
    });
  }, [sentInterestIds, profileList]);

  return (
    <section className="py-4 px-4 sm:px-6 lg:px-8 bg-transparent">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="max-w-8xl mx-auto relative"
      >
        <div className="text-left">
          <div
            className="block md:flex md:justify-between md:items-center gap-4"
            style={{ justifyContent: "space-between" }}
          >
            <div className="trending-slider-header">
              <motion.div
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="trending-label"
              >
                <Sparkles className="trending-label-icon" />
                <span className="trending-label-text">
                  {t("Trending Now")}
                </span>
              </motion.div>

              <motion.h2
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="trending-title"
              >
                {t("Most Viewed Profiles")}
              </motion.h2>

              <motion.p
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="trending-subtitle"
              >
                {t(
                  "Discover the most popular and verified profiles in your area"
                )}
              </motion.p>
            </div>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleFilterClick}
              style={{ height: "4vh", padding: "20px" }}
              className="flex items-center gap-2 px-3 py-2  border border-red-500 rounded-xl text-red-600 font-semibold hover:shadow-lg transition-all duration-300 w-fit cursor-pointer"
            >
              <Funnel size={18} />
              {!isMobile && (
                <span className="inline sm:hidden">{t("Filter")}</span>
              )}
              <ChevronDown size={16} />
            </motion.button>
          </div>

          <Popover
            open={open}
            anchorEl={filterAnchor}
            onClose={handleFilterClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            sx={{
              "& .MuiPopover-paper": {
                borderRadius: "16px",
                boxShadow: "0 20px 40px rgba(220, 38, 38, 0.15)",
                border: "1px solid #FACC15",
                marginTop: "8px",
                minWidth: "220px",
                overflow: "hidden",
              },
            }}
          >
            <Box sx={{ p: 3 }}>
              <Typography
                variant="subtitle2"
                sx={{
                  color: "#DC2626",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 3,
                  fontSize: "14px",
                }}
              >
                <Calendar size={16} />
                {t("Select Period")}
              </Typography>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {[
                  {
                    value: "today",
                    label: t("Today"),
                    icon: <TodayIcon />,
                  },
                  {
                    value: "week",
                    label: t("This Week"),
                    icon: <WeekIcon />,
                  },
                ].map((option, index) => (
                  <motion.button
                    key={option.value}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => handlePeriodChange(option.value)}
                    className={`flex items-center gap-3 px-4 py-3 rounded-xl border transition-all duration-300 font-semibold cursor-pointer
                    ${period === option.value
                        ? "text-white shadow-lg"
                        : "bg-white text-gray-700 border border-gray-200 hover:bg-rose-50 hover:text-rose-600 hover:border-rose-300"
                      }`}
                    style={{
                      background: period === option.value ? "linear-gradient(to bottom right, #DC2626, #991B1B)" : "",
                      borderColor: period === option.value ? "#991B1B" : "",
                    }}
                  >
                    <span
                      style={{
                        color:
                          period === option.value
                            ? "text-white"
                            : "text-rose-600",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {option.icon}
                    </span>
                    <span className="font-medium">{option.label}</span>
                  </motion.button>
                ))}
              </Box>

              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={handleFilterClose}
                className="w-full mt-4 py-3 rounded-xl border border-gray-200 bg-white text-gray-600 font-medium hover:bg-gray-50 hover:shadow-md transition-all cursor-pointer"
              >
                {t("Close")}
              </motion.button>
            </Box>
          </Popover>
        </div>

        <div className="w-full bg-transparent mt-6">
          {trendinglistLoadding ? (
            <ProfileCardsSkeleton card={4} showHeader={false} />
          ) : (
            trendinglist.length > 0 && (
              <TrendingProfilesSlider
                profiles={trendinglist}
                layoutType="horizontal"
                onNavigate={(profile) => {
                  const id = profile?.basicProfile?.user_id || profile?.user_id;
                  console.log("Clicked profile id:", id);
                  handleProfileClick(profile);
                }}
              />
            )
          )}
        </div>
      </motion.div>
      <Divider sx={{ my: 4, backgroundColor: "#f3f4f6", height: "2px" }} />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
        className="max-w-8xl mx-auto"
      >
        <div className="trending-slider-header">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="trending-label"
          >
            <Sparkles className="trending-label-icon" />
            <span className="trending-label-text">{t("Explore Now")}</span>
          </motion.div>

          <motion.h2
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="trending-title"
          >
            {t("Explore All Profiles")}
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="trending-subtitle"
          >
            {t(
              "Discover verified profiles of potential partners who share your values and aspirations"
            )}
          </motion.p>
        </div>

        {/* Profiles Grid - Show 3 profiles + 1 View All card */}
        <div className="w-full bg-transparent mt-6">
          {profileListLoadding ? (
            <ProfileCardsSkeleton card={4} showHeader={false} />
          ) : (
            /* First 3 Profile Cards */
            displayProfiles.length > 0 && (
              <TrendingProfilesSlider
                profiles={profileList.slice(0, 4)}
                layoutType="horizontal"
                onNavigate={(profile) => {
                  const id = profile?.basicProfile?.user_id || profile?.user_id;
                  console.log("Clicked profile id:", id);
                  handleProfileClick(profile); // async tracking + navigation inside
                }}
              />
            )
          )}
        </div>
      </motion.div>

      <AlertDialog open={showLoginDialog} onOpenChange={setShowLoginDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("You’re Almost There!")}</AlertDialogTitle>
            <AlertDialogDescription>
              {t("Log in to explore profiles and start connecting")}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => setShowLoginDialog(false)}
              className="cursor-pointer"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="text-white cursor-pointer"
              style={{ background: 'linear-gradient(to bottom right, #DC2626, #991B1B)' }}
              onClick={() => {
                setShowLoginDialog(false);
                dispatch(setCurrentPage("login"));
              }}
            >
              {t("Login")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog
        open={showSubscribeDialog}
        onOpenChange={setShowSubscribeDialog}
      >
        <AlertDialogContent className="max-w-sm text-center">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-red-600 text-xl font-semibold">
              🔔 {t("Subscription Required")}
            </AlertDialogTitle>
            <AlertDialogDescription className="text-gray-600 mt-2">
              {t("Upgrade your plan to explore more matches")}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <div className="flex justify-center gap-3 mt-4">
            <AlertDialogCancel
              onClick={() => setShowSubscribeDialog(false)}
              className="cursor-pointer border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-lg"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="text-white cursor-pointer"
              style={{ background: 'linear-gradient(to bottom right, #DC2626, #991B1B)' }}
              onClick={() => {
                setShowSubscribeDialog(false);
                navigate("/subscription");
                dispatch(setCurrentPage("subscription"));
              }}
            >
              {t("Subscribe Now")}
            </AlertDialogAction>
          </div>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog
        open={openCompletionDialog}
        onOpenChange={setOpenCompletionDialog}
      >
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t("Your Journey Starts Here")}</AlertDialogTitle>

            <AlertDialogDescription>
              {t(
                "Complete your profile to unlock full access and explore profiles"
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>

          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => setOpenCompletionDialog(false)}
              className="cursor-pointer border border-gray-300 hover:bg-gray-100 px-4 py-2 rounded-lg"
            >
              {t("Cancel")}
            </AlertDialogCancel>
            <AlertDialogAction
              className="text-white cursor-pointer"
              style={{ background: 'linear-gradient(to bottom right, #DC2626, #991B1B)' }}
              onClick={() => {
                setOpenCompletionDialog(false);
                navigate("/profile");
                dispatch(setCurrentPage("profile"));
              }}
            >
              {t("Continue")}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </section>
  );
}
